export const forums = {
  forumsSearchInputPlaceholder: 'Buscar',
  forumsFollowDiscussionButtonTitle: 'Seguir',
  forumsFollowingDiscussButtonTitle: 'Siguiendo',
  forumDiscussionInfoNoReplyText: 'Sin respuestas aún',
  forumsDiscussionDetailsStartButtonTitle: 'Iniciar discusión',
  forumDetailsCreatedByText: 'por',
  forumsDiscussionDetailsUsersCurtainCopyOptionTitle: 'Copiar enlace',
  forumsDiscussionDetailsUsersCurtainFlagOptionTitle: 'Informar contenido',
  forumsReportedCurtainContent: 'Contenido informado',
  forumsDiscussionDetailsUserCurtainCopiedAlertText: 'Enlace copiado!',
  forumsDiscussionDetailsOwnersCurtainPinOptionTitle: 'Anclar discusión',
  forumsDiscussionDetailsOwnersCurtainUnpinOptionTitle: 'Desanclar discusión',
  forumsDiscussionDetailsOwnersCurtainEditOptionTitle: 'Editar discusión',
  forumsDiscussionDetailsOwnersCurtainDeleteOptionTitle: 'Eliminar discusión',
  forumsDiscussionDetailspPopupDeleteTitle: 'Eliminar',
  forumsDiscussionDetailspPopupDeleteText: '¿Eliminar esta discusión?',
  forumsDiscussionDetailspPopupCancelButtonTitle: 'Cancelar',
  forumsDiscussionDetailspPopupConfirmButtonTitle: 'Confirmar',
  forumsDiscussionDetailsDeleledAlertText: '¡Discusión eliminada!',
  forumsNewDiscussionTitle: 'Nueva discusión',
  forumsNewDiscussionTitlePlaceholder: 'Título...',
  forumsNewDiscussionBodyPlaceholderText: 'Escribe tu texto aquí...',
  forumsNewDiscussionPublishButtonTitle: 'Publicar',
  forumsNewDiscussionLocationCurtainTitle: 'Ubicación',
  forumsNewDiscussionLocationCurtainInputPlaceholder: 'Nombre de la ubicación',
  forumsNewDiscussionEditLocationCurtainText: 'Editar ubicación',
  forumsNewDiscussionDeleteLocationCurtainText: 'Eliminar ubicación',
  forumsNewDiscussionCreatePollTitle: 'Crear encuesta',
  forumsNewDiscussionTitleInputPlaceholder: 'Título',
  forumsNewDiscussionOptionInputPlaceholder: 'Opción',
  forumsNewDiscussionAddButtonTitle: 'Agregar opción',
  forumsNewDiscussionCreateButtonTitle: 'Crear',
  forumsNewDiscussionPollTitleBlankAlertText: 'El título no puede estar en blanco!',
  forumsNewDiscussionPollOptionBlankAlertText: 'La opción no puede estar en blanco!',
  forumsNewDiscussionPollLongTitleAlertText: 'El título debe tener como máximo 140 caracteres',
  forumsNewDiscussionPollLongOptionAlertText: 'La opción debe tener como máximo 50 caracteres',
  forumsNewDiscussionEditPollIconText: 'Editar encuesta',
  forumsNewDiscussionRemovePollIconText: 'Eliminar encuesta',
  forumsDiscardDraftPopupTitle: 'Borrador',
  forumsDiscardDraftPopupText: '¿Descartar este borrador?',
  forumsDiscardDraftPopupCancelButtonTitle: 'Cancelar',
  forumsDiscardDraftPopupConfirmButtonTitle: 'Confirmar',
  forumsDiscussionDetailsPostBodyReplyIconTitle: 'Responder',
  forumsDiscussionDetailsNoCommentsText: 'Aún no hay comentarios\nPuedes ser el primero en comentar',
  forumsDiscussionDetailsReplyInputPlaceholder: 'Responder',
  forumsDiscussionDetailsPostShareCurtainOptionTitle: 'Copiar enlace',
  forumsDiscussionDetailsPostShareCopiedAlertText: 'Enlace copiado!',
  forumsDiscussionDetailsPostUsersCurtainFlagOptionTitle: 'Informar contenido',
  forumsDiscussionDetailsPostCurtainReportedText: 'Contenido informado',
  forumsDiscussionDetailsCommentReplyIconTitle: 'Responder',
  forumsEditDiscussionTitle: 'Editar discusión',
  forumsEditDiscussionSaveButtonTitle: 'Guardar',
  forumsEditedDiscussionSavedAlertText: '¡Discusión guardada!',
  forumsDiscussionDetailsOwnersCommentCurtainEditOptionTitle: 'Editar respuesta',
  forumsDiscussionDetailsOwnersCommentCurtainDeleteOptionTitle: 'Eliminar respuesta',
  forumsDiscussionDetailsEditedCommSavedAlertText: '¡Comentario guardado!',
  forumsDiscussionDetailsEditedCommDeletedAlertText: '¡Comentario eliminado!',
  forumsAlertSomethinWrong: '¡Algo salió mal!',
  forumsMaxMbSize: 'Solo puedes cargar hasta {size} MB a la vez',
  forumsMaxAttachments: 'Has excedido el número máximo de adjuntos. El máximo de adjuntos es {max}',
  forumsDiscussionDetailsDeleteCommentPopupTitle: 'Eliminar',
  forumsDiscussionDetailsDeleteCommentPopupText: '¿Eliminar este comentario?',
  forumsDiscussionDetailsDeleteCommentPopupCancelButtonTitle: 'Cancelar',
  forumsDiscussionDetailsDeleteCommentPopupConfirmlButtonTitle: 'Confirmar',
  forumsDiscussionDetailsUsersCommentCurtainFlagOptionTitle: 'Informar contenido',
  forumsDiscussionDetailsCommentReportedCurtainText: 'Contenido informado',
  forumDiscussionInfoLastReplyText: 'Última respuesta',
  forumsDiscussionAt: 'en',
  forumsDiscussionDetailsFlagCurtainTitle: 'Informar contenido',
  forumsDiscussionDetailsFlaggedReportedCurtainContent: 'Contenido informado',
  forumsPollInfoVotesText: 'votos',
  forumsPollInfoEditVoteText: 'Editar voto',
  forumsPollFinishPollText: 'Finalizar encuesta',
  forumsPollFinishedPollText: 'Finalizada',
  forumsPollInProgresslText: 'En progreso',
  forumsPollCurtainTitle: 'Finalizar encuesta',
  forumsPollCurtainText: 'Los usuarios no podrán votar después de que se cierre la encuesta.',
  forumsFinishPollCurtainCancelButtonTitle: 'Cancelar',
  forumsFinishPollCurtainConfirmlButtonTitle: 'Confirmar',
  forumsPollInfoPollVotesCurtainTitle: 'Votos en la encuesta'
}
